import * as React from 'react';
import { observer } from 'mobx-react';

import { UitkTab, UitkTabs } from 'uitk-react-tabs';

import { useStores } from 'utility/hooks';
import { trackAnalytics } from 'utility';

import { SearchTripControls, SearchFormOptions } from '.';
import { FlightsSearchFormTripTypeOptionItem } from 'types/search/wizard';
import { InteractableFieldComponentProps } from 'types/shared';

export interface TripTabsProps extends InteractableFieldComponentProps {
  essEndpoint?: string;
}

export const TripTabs = observer(({ essEndpoint, onFieldInteraction }: TripTabsProps) => {
  const { analytics, searchFormStore } = useStores();
  const { searchForm, tripTypeOptions, selectedTripTypeOptionItem } = searchFormStore;

  const handleSelect = (selectedTabLabel: string) => {
    onFieldInteraction && onFieldInteraction();
    searchFormStore.setSelectedTripType(selectedTabLabel, 'label');

    if (selectedTripTypeOptionItem.label !== selectedTabLabel) {
      const newSelectedTripTypeOptionItem = searchFormStore.selectedTripTypeOptionItem;
      trackAnalytics(newSelectedTripTypeOptionItem.tripTypeSelectedAnalytics, analytics);
    }
  };

  return (
    <UitkTabs onTabSelect={handleSelect} selectedTab={selectedTripTypeOptionItem.label}>
      {tripTypeOptions.items.map((trip: FlightsSearchFormTripTypeOptionItem) => (
        <UitkTab key={`tab-${trip.tripType}`} name={trip.label} className="uitk-type-300">
          {selectedTripTypeOptionItem.label === trip.label && (
            <>
              <SearchTripControls essEndpoint={essEndpoint} onFieldInteraction={onFieldInteraction} />
              <SearchFormOptions options={searchForm.searchOptions} onFieldInteraction={onFieldInteraction} />
            </>
          )}
        </UitkTab>
      ))}
    </UitkTabs>
  );
});
